import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/DeleteGeminiThread.graphql';
import { Mutation, MutationdeleteGeminiThreadArgs } from '../../__generated__/globalTypes';

export const useDeleteGeminiThreadMutation = (
  options?: MutationHookOptions<Mutation, MutationdeleteGeminiThreadArgs>
) => {
  const [callDeleteGeminiThread, result] = useMutation<Mutation, MutationdeleteGeminiThreadArgs>(MUTATION, options);

  return { callDeleteGeminiThread, ...result };
};

export type DeleteGeminiThreadMutationFunction = Mutation['deleteGeminiThread'];
